export default "__VITE_ASSET__cn_If4pj__"